<template>
  <div class="return-order-com">
    <div class="up-date">
      <span>更新时间 :</span>
      {{ returnItem.subTime }}
    </div>
    <div class="return-order-table" style="margin-top:20px;">
      <template v-if="returnItem.apiTypeActive == 'pop'">
        <el-table
          :data="tableList"
          v-loading="tableLoading"
          :header-cell-style="{ background: '#FAFAFA' }"
          style="width: 100%;border: 1px solid #eaeaea;"
        >
          <el-table-column label="客户pin">
            <template slot="header" slot-scope="scope">
              <div>客户pin</div>
            </template>
            <template slot-scope="scope">{{ scope.row.nickName }}</template>
          </el-table-column>

          <el-table-column label="催评时间" class="special">
            <template slot-scope="scope">
              <span>{{ returnItem.subTime }}</span>
            </template>
          </el-table-column>

          <el-table-column label="订单编号" class="special">
            <template slot-scope="scope">{{ scope.row.orderId }}</template>
          </el-table-column>

          <el-table-column label="sku id" class="special">
            <template slot-scope="scope">{{ scope.row.skuIdStr }}</template>
          </el-table-column>

          <el-table-column label="评价时间" class="special">
            <template slot-scope="scope">
              <span>{{ scope.row.creationTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="评价等级" class="special">
            <template slot-scope="scope">
              <span>{{ scope.row.score || 0 }}星</span>
            </template>
          </el-table-column>

          <el-table-column class="special" width="250">
            <template slot="header" slot-scope="scope">
              <span>评价内容</span>
              <span @click="isShowTextAll" :style="{ color: changeColor }" style="padding-left:10px; cursor: pointer;">{{
                isShowAll ? "单行显示" : "展开全部"
              }}</span>
            </template>
            <template slot-scope="scope">{{ scope.row.content | overFloatContent(isShowAll) }}</template>
          </el-table-column>
        </el-table>
      </template>
      <el-table
        v-else
        :data="tableList"
        v-loading="tableLoading"
        :header-cell-style="{ background: '#FAFAFA' }"
        style="width: 100%;border: 1px solid #eaeaea;"
      >
        <el-table-column label="买家昵称">
          <template slot="header">
            <div>买家昵称</div>
          </template>
          <template slot-scope="scope">{{ scope.row.desensitizePin }}</template>
        </el-table-column>
        <el-table-column label="买家号码">
          <template slot="header" slot-scope="scope">
            <div>手机号码</div>
          </template>
          <template slot-scope="scope">{{ scope.row.mobile || "--" }}</template>
        </el-table-column>

        <el-table-column label="实付金额(元)">
          <template slot-scope="scope">{{ scope.row.payment }}</template>
        </el-table-column>

        <el-table-column label="催付时间" class="special">
          <template slot="header" slot-scope="scope">
            <div>催付时间</div>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.subTime }}</span>
          </template>
        </el-table-column>

        <el-table-column label="付款时间" class="special">
          <template slot="header" slot-scope="scope">
            <div>付款时间</div>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.payTime }}</span>
          </template>
        </el-table-column>
        <el-table-column class="special" width="250">
          <template slot="header" slot-scope="scope">
            <span>短信内容</span>
            <span @click="isShowTextAll" :style="{ color: changeColor }" style="padding-left:10px; cursor: pointer;">{{
              isShowAll ? "单行显示" : "展开全部"
            }}</span>
          </template>
          <template slot-scope="scope">{{ scope.row.content | overFloatContent(isShowAll) }}</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page" style="margin:20px 0 10px 0;height:32px;">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        @size-change="handleSizeChange"
        :page-size="pageSize"
        style="float:right;"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getPopCommentInfo } from "@/api/care/popCommentConfigController";
import { getRedeemInfo } from "@/api/care/orderCare";
import { mapState } from "vuex";
const EXPOR_PUT_FILED = ["买家昵称", "买家号码", "实付金额(元)", "催付时间", "付款时间", "模板内容"];
export default {
  props: {
    returnItem: {
      type: Object,
    },
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  data() {
    return {
      total: 0,
      isShowAll: false,
      tableLoading: false,
      pageNum: 1,
      menuType: "",
      pageSize: 10,
      tableList: [],
    };
  },
  filters: {
    //展开收缩
    overFloatContent(d, s) {
      try {
        if (!s) {
          return d.length <= 20 ? d : d.substr(0, 20) + "...";
        } else {
          return d;
        }
      } catch (e) {
        return "...";
      }
    },
  },
  watch: {
    returnItem(newVal, oldVal) {
      this.pageNum = 1;
      this.pageSize = 10;
      this._getPaymentInfoList();
    },
  },
  created() {
    console.log(this.pageSize, this.pageNum);
    this.menuType = this.$parent.$parent.asideActive;

    this._getPaymentInfoList();
  },
  methods: {
    //分页
    async handleCurrentChange(v) {
      this.pageNum = v;
      await this._getPaymentInfoList();
    },
    async handleSizeChange(v) {
      this.pageSize = v;
      await this._getPaymentInfoList();
    },
    isShowTextAll() {
      this.isShowAll = !this.isShowAll;
    },

    //获取挽回数据List
    _getPaymentInfoList() {
      this.tableLoading = true;
      let params = {
        current: this.pageNum, //(integer, optional): 当前页 ,
        size: this.pageSize, //(integer, optional): 每页大小 ,
        subTime: this.returnItem.subTime, //(string, optional): 短信提交时间 今日数据传入当日时间yyyy-MM-dd ,
        // type: this.returnItem.type
        analysisType: this.returnItem.analysisType,
      };
      if(params.analysisType == 1) params.taskId = this.returnItem.taskId
      if (this.returnItem.apiTypeActive == "pop") {
        getPopCommentInfo(params).then(({ data }) => {
          this.tableLoading = false;
          this.tableList = data.records;
          this.total = data.total;
        });
      } else {
        params.type = this.returnItem.type;
        if (params.subTime && params.subTime.length > 0) {
          params.subTime = params.subTime.substr(0, 10);
        }
        getRedeemInfo(params).then(({ data }) => {
          this.tableLoading = false;
          this.tableList = data.records;
          this.total = data.total;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.return-order-com {
  .exportBtn {
    height: 30px;
    float: right;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: middle;
    padding: 0px 12px;
    border: 1px solid #2062e7;
    color: #2062e7;
    font-size: 16px;
    line-height: 25px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    margin-right: 15px;
    cursor: pointer;
    .button-icon {
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
    }
    .button-title {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .export_btn2 {
    width: 32px;
    height: 32px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(204, 204, 204, 1);
    opacity: 1;
    border-radius: 4px;
    margin-right: 2px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
    float: right;
  }
  .up-date {
    height: 32px;
    line-height: 32px;
  }
}
</style>
